/**
 * Array Utility methods
 */
export const ArrayUtils = {
    /**
     * Filter out a given value from array
     *
     * @param array
     * @param value
     */
    arrayRemove: <T>(array: Array<T>, value: T): Array<T> => {
        return array.filter((ele) => {
            return ele != value
        })
    }
}
